/* eslint-disable @typescript-eslint/no-unused-vars */
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import { loadMultipleAppTranslations } from "@/i18n/translationLoader";

export const personLoginGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> => {
  try {
    await loadMultipleAppTranslations(["login", "shared"]);
    if (!to.query.afterLogin) {
      next({ name: RouteName.M3MerchantLogin, replace: true, query: to.query });
      return;
    }

    next();
  } catch (error) {
    console.error("Failed to load login translations:", error);
    // Continue anyway - don't block navigation due to translation errors

    if (!to.query.afterLogin) {
      next({ name: RouteName.M3MerchantLogin, replace: true, query: to.query });
      return;
    }

    next();
  }
};
